import React from 'react';
import {
  Carousel,
  CarouselCard,
  CarouselNav,
  CarouselNavButton,
  CarouselNavContainer,
  CarouselViewport,
  CarouselSlider,
} from '@fluentui/react-carousel';
import { mergeClasses, Skeleton, SkeletonItem } from '@fluentui/react-components';
import PropTypes from 'prop-types';
import { useTemplateCarouselStyles } from './style';

const CarouselItem = ({ url, i18n }) => {
  const classes = useTemplateCarouselStyles();
  return (
    <div className={mergeClasses(classes.carousel, classes.carouselItemContainer)}>
      <img className={classes.carouselItem} src={url} alt={i18n.getString(_TL_('Template preview'))} />
    </div>
  );
};

CarouselItem.propTypes = {
  url: PropTypes.string.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};

export const TemplateDetailsCarousel = ({
  previews, loading, i18n,
}) => {
  const classes = useTemplateCarouselStyles();
  const [activeIndex, setActiveIndex] = React.useState(0);

  const handleActiveIndexChange = (_event, data) => {
    if (data && data.index) {
      setActiveIndex(data.index);
    }
  };

  return (
    <>
      {loading || previews === undefined || previews.length === 0 ? (
        <Skeleton
          className={classes.carousel}
          aria-label={i18n.getString(_TL_('Loading carousel'))}
          animation="wave"
        >
          <SkeletonItem size={128} />
        </Skeleton>) : (
          <Carousel onActiveIndexChange={handleActiveIndexChange} groupSize={1} circular align="center" className={mergeClasses('template-details-carousel', classes.carousel)}>
            <CarouselViewport>
              <CarouselSlider>
                {previews.map(preview => (
                  <CarouselCard key={preview} className={classes.carousel}>
                    <CarouselItem url={preview} i18n={i18n} />
                  </CarouselCard>
                ))}
              </CarouselSlider>
            </CarouselViewport>
            <CarouselNavContainer
              layout="overlay-expanded"
              next={{ 'aria-label': i18n.getString(_TL_('go to next')), shape: 'circular' }}
              prev={{ 'aria-label': i18n.getString(_TL_('go to prev')), shape: 'circular' }}
            >
              <CarouselNav>
                {() => (
                  <CarouselNavButton aria-label={i18n.getString(_TL_('Preview'))} />
                )}
              </CarouselNav>
            </CarouselNavContainer>
          </Carousel>
      )}
      {previews && previews.length > 0 && (
        <span className={classes.carouselLiveAnnouncer} aria-live="assertive">
          {i18n.getString(_TL_('Switched to template preview {{index}} of {{totalCount}}'), { index: activeIndex + 1, totalCount: previews.length })}
        </span>
      )}
    </>
  );
};


TemplateDetailsCarousel.propTypes = {
  previews: PropTypes.arrayOf(PropTypes.string).isRequired,
  loading: PropTypes.bool,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};

TemplateDetailsCarousel.defaultProps = {
  loading: false,
};
